import styled from '@emotion/styled'
import { Button as AntdButton } from 'antd'
import Modal from '@/components/common/Modal'

export const Button = styled(AntdButton)``

export const Content = styled('div')`
  padding-top: 10px;
  color: #666666;
`

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 12px;
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .ant-modal-header {
    border-bottom: none;
    padding: 20px 24px 8px 24px;

    .ant-modal-title {
      font-weight: 600;
      font-size: 18px;
      color: #333;
    }
  }

  .ant-modal-body {
    padding: 0px 24px 20px 24px;
  }

  .ant-modal-footer {
    border-top: none;
    background-color: #f8f9fa;
    padding: 16px 24px;
    gap: 8px;
  }
`
